// 環境に非依存な定数をここに定義する
// 例：システム共通のプレフィックス値など
const constant = {
  "s3_tenant_prefix": "tenant",
  "iconpath": {
    "icon1": "statusicon/ic_circle_blue.png",
    "icon2": "statusicon/ic_circle_green.png",
    "icon3": "statusicon/ic_circle_grey.png",
    "icon4": "statusicon/ic_circle_red.png",
    "icon5": "statusicon/ic_circle_yellow.png",
    "icon6": "statusicon/ic_star_blue.png",
    "icon7": "statusicon/ic_star_green.png",
    "icon8": "statusicon/ic_star_gray.png",
    "icon9": "statusicon/ic_star_red.png",
    "icon10": "statusicon/ic_star_yellow.png",
    "icon11": "statusicon/ic_triangle_blue.png",
    "icon12": "statusicon/ic_triangle_green.png",
    "icon13": "statusicon/ic_triangle_grey.png",
    "icon14": "statusicon/ic_triangle_red.png",
    "icon15": "statusicon/ic_triangle_yellow.png"
  },
  "sumigomuicon": [ 
    {"type": "1", "name": "(安検)1", "key": "statusicon/1-1.png", "path": "blank" },
    {"type": "2", "name": "(安検)2", "key": "statusicon/1-2.png", "path": "blank" },
    {"type": "3", "name": "(安検)3-1", "key": "statusicon/1-3-1.png", "path": "blank" },
    {"type": "4", "name": "(安検)3-2", "key": "statusicon/1-3-2.png", "path": "blank" },
    {"type": "5", "name": "(安検)4", "key": "statusicon/1-4.png", "path": "blank" },   
    {"type": "6", "name": "(安検)0", "key": "statusicon/1-0.png", "path": "blank" },
    {"type": "7", "name": "(報説)1", "key": "statusicon/2-1.png", "path": "blank" },
    {"type": "8", "name": "(報説)2", "key": "statusicon/2-2.png", "path": "blank" },
    {"type": "9", "name": "(報説)3", "key": "statusicon/2-3.png", "path": "blank" },
    {"type": "10", "name": "(報説)4", "key": "statusicon/2-4.png", "path": "blank" },
    {"type": "11", "name": "(交換)1-1", "key": "statusicon/3-1-1.png", "path": "blank" },
    {"type": "12", "name": "(交換)1-2", "key": "statusicon/3-1-2.png", "path": "blank" },
    {"type": "13", "name": "(交換)2", "key": "statusicon/3-2.png", "path": "blank" },
    {"type": "14", "name": "(交換)3-1", "key": "statusicon/3-3-1.png", "path": "blank" },
    {"type": "15", "name": "(交換)3-2", "key": "statusicon/3-3-2.png", "path": "blank" },
    {"type": "16", "name": "(交換)4", "key": "statusicon/3-4.png", "path": "blank" },
    {"type": "17", "name": "(交換)5-1", "key": "statusicon/3-5-1.png", "path": "blank" },
    {"type": "18", "name": "(交換)5-2", "key": "statusicon/3-5-2.png", "path": "blank" },
    {"type": "19", "name": "(クロ)1", "key": "statusicon/4-1.png", "path": "blank" },
    {"type": "20", "name": "(クロ)2", "key": "statusicon/4-2.png", "path": "blank" },
  ]
}

export default constant;